import { render, staticRenderFns } from "./UploadStatus.vue?vue&type=template&id=063e6c06&"
import script from "./UploadStatus.vue?vue&type=script&lang=js&"
export * from "./UploadStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports